/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { CSSProperties } from "react";

import { useTranslation } from "react-i18next";

import { generateTranslatedText } from "@/shared/functions/functions";
import Typography from "@mui/material/Typography";

import {
  Filter,
  inputFieldMarginBottom,
  TABLE_NAMES
} from "../../../../../../../shared";
import Badge from "../../../../../../Badge/Badge";
import { useStyles as useInfoBlockStyles } from "../styles";

interface ItemsInfoBlockProps {
  resourceName: TABLE_NAMES;
  isAllTab: boolean;
  generateSelectedTabDescription: () => string | undefined;
  generateBadgeText: () => string | undefined;
  generateItemsCountToDisplay: () => string | number | undefined;
  displayFilters: boolean;
  filteredValues: Filter[];
}

const ItemsInfoBlock = ({
  resourceName,
  isAllTab,
  generateSelectedTabDescription,
  generateBadgeText,
  generateItemsCountToDisplay,
  displayFilters,
  filteredValues
}: ItemsInfoBlockProps) => {
  const { dialogContent, customBadge, usedFiltersBlock } = useInfoBlockStyles();

  const { i18n, t } = useTranslation();

  const generateFilteredValuesBadges = () =>
    filteredValues?.map((value: { id: string; name: string }) => (
      <Badge
        key={value.id}
        color="info"
        customStyle={[customBadge as CSSProperties, { marginRight: "4px" }]}
        changeTypography
      >
        <Typography variant="body2Medium">
          {generateTranslatedText(value.name, i18n, t)}
        </Typography>
      </Badge>
    ));

  return (
    <div
      css={css(dialogContent)}
      data-testid={`selected-${resourceName}-schedules-badge`}
    >
      <Typography
        variant="body2Medium"
        sx={isAllTab ? undefined : inputFieldMarginBottom}
      >
        {generateSelectedTabDescription()}
      </Typography>

      {!isAllTab && (
        <Badge
          color="info"
          customStyle={customBadge as React.CSSProperties}
          changeTypography
        >
          <Typography variant="body2Medium">
            {`${generateBadgeText()}: ${generateItemsCountToDisplay()}`}
          </Typography>
        </Badge>
      )}

      {displayFilters && (
        <div css={css(usedFiltersBlock)}>
          <Typography variant="body2Medium" sx={{ marginRight: "4px" }}>
            {t("Filter##filters used")}:
          </Typography>
          {generateFilteredValuesBadges()}
        </div>
      )}
    </div>
  );
};

export default ItemsInfoBlock;
